// program states
export const AUTOMATIC_PROGRAM = 0;
export const SPECIAL_PROGRAM = 1;
export const MANUAL_PROGRAM = 2;
export const LOCAL_PROGRAM = 3;
export const UNKNOWN = 4;

// program states german translations
export const AUTOMATIC_PROGRAM_TRANSLATION_GER = 'Automatikprogramm';
export const SPECIAL_PROGRAM_TRANSLATION_GER = 'Sonderprogramm';
export const MANUAL_PROGRAM_TRANSLATION_GER = 'Handprogramm';
export const LOCAL_PROGRAM_TRANSLATION_GER = 'Vorortbetrieb';
export const UNKNOWN_TRANSLATION_GER = 'N/A';
